import * as React from 'react';
import { Box, Menu, MenuItem } from '@mui/material';

import { ReactComponent as OptionDropDown } from 'assets/images/option-drop-down.svg';
import palette from 'ui/theme/palette';
import type { MenuOption } from '../../molecules';
import { Tooltip } from '..';

interface Props {
  menuOptions: MenuOption[];
}

export const MeatballMenu: React.FC<Props> = (props) => {
  const { menuOptions } = props;
  const [menuEl, setMenuEl] = React.useState<Element>();

  return (
    <>
      <Box
        sx={{
          cursor: 'pointer',
          width: '36px',
          height: '36px',
          boxShadow: Boolean(menuEl) ? `0px 0px 0px 3px rgba(3, 166, 91, 0.25)` : `0px`,
          borderRadius: '50%',
          '&: hover': {
            background: `${palette.background.paper}`
          },
          '& svg': {
            fill: Boolean(menuEl) ? `${palette.background.paper}` : '',
            '& path': {
              fill: Boolean(menuEl) ? `${palette.text.primary}` : undefined
            },
            '& rect': {
              stroke: Boolean(menuEl) ? `${palette.primary.main}` : ''
            },

            '&: hover': {
              '& path': {
                fill: `${palette.primary.main}`
              },
              '& rect': {
                stroke: `${palette.primary.main}`
              }
            }
          }
        }}
        onClick={(event) => {
          setMenuEl(event.currentTarget);
        }}
      >
        <OptionDropDown />
      </Box>
      <Menu
        id="multi-action-button"
        anchorEl={menuEl}
        open={Boolean(menuEl)}
        onClose={() => setMenuEl(undefined)}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {menuOptions.map((m) => {
          return (
            <MenuItem
              disabled={m.disabled}
              onClick={(e) => {
                e.stopPropagation();
                setMenuEl(undefined);
                m.onClick();
              }}
            >
              <Tooltip
                variant="text"
                disabled={!m.disabled}
                title={m.toolTip ? m.toolTip : ''}
                placement="top"
              >
                {m.label}
              </Tooltip>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};
